import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ntpe-navigation',
    templateUrl: './ntpe-navigation.component.html',
    styleUrls: ['./ntpe-navigation.component.scss']
})
export class NtpeNavigationComponent implements OnInit {
    @Input() tabIndex?: number;
    @Input() rubricNavigationEnabled?: boolean = false;

    @Output() navigate = new EventEmitter<number>();
    @Output() save = new EventEmitter<boolean>();

    constructor() { }

    ngOnInit(): void {
    }

    saveClicked() {
        this.save.emit(true);
    }

    setTabIndex(num: number) {
        this.navigate.emit(num);
    }

    rubricEnabled() {
        return this.rubricNavigationEnabled ? "" : "disabled";
    }
}
